module.exports = __webpack_public_path__ + "img/ringbank.60041bb.jpg";